const placeholderArtStyles = [
    {
        name: 'Mountain Range',
        description:
            'Layered peaks fading into a distant horizon. Price is tracked by the tallest mountain.',
    },
    {
        name: 'Constellation Map',
        description:
            'Each candle becomes a star — price sets position, volume sets brightness.',
    },
    {
        name: 'City Skyline',
        description:
            'Neon-lit cyberpunk towers pierce the night — powerlines track price movements.',
    },
    {
        name: 'Kowloon',
        description:
            'Dense ink-drawn architecture — stacked buildings and scaffolding trace the price silhouette.',
    },
];

const ArtStyleFields = ({ value = null, onChange = () => {}, error }) => {
    return (
        <div id="art-style-column" className="form-column">
            <label id="art-style-label">3. Select an Art Style</label>
            {value && (
                <div className="art-style-selected">
                    <div className="art-style-selected-header">
                        <p className="art-style-selected-label">
                            Selected Art Style
                        </p>
                        <button
                            type="button"
                            className="art-style-selected-clear"
                            aria-label={`Remove ${value.name}`}
                            onClick={() => onChange(null)}
                        >
                            x
                        </button>
                    </div>
                    <div className="art-style-selected-body">
                        <span
                            className="art-style-selected-preview"
                            aria-hidden="true"
                        />
                        <div className="art-style-selected-info">
                            <span className="art-style-selected-name">
                                {value.name}
                            </span>
                            <span className="art-style-selected-description">
                                {value.description}
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div
                className="art-style-list"
                role="listbox"
                aria-labelledby="art-style-label"
                aria-describedby={error ? 'art-style-error' : undefined}
                aria-invalid={Boolean(error)}
            >
                {placeholderArtStyles.map((style) => (
                    <button
                        key={style.name}
                        type="button"
                        className={`art-style-option${
                            value?.name === style.name ? ' selected' : ''
                        }`}
                        role="option"
                        aria-selected={value?.name === style.name}
                        onClick={() => onChange(style)}
                    >
                        <span
                            className="art-style-preview"
                            aria-hidden="true"
                        />
                        <span className="art-style-copy">
                            <span className="art-style-name">{style.name}</span>
                            <span className="art-style-description">
                                {style.description}
                            </span>
                        </span>
                    </button>
                ))}
                <button
                    type="button"
                    className="art-style-option art-style-option--coming-soon"
                    disabled
                    aria-disabled="true"
                >
                    <span className="art-style-copy">
                        <span className="art-style-name">
                            More styles coming soon
                        </span>
                    </span>
                </button>
            </div>
            {error && (
                <p className="form-validation-error" id="art-style-error">
                    {error}
                </p>
            )}
        </div>
    );
};

export default ArtStyleFields;
